import { useState, useEffect } from 'react';
import Logger from 'utilities/logger';
global.appVersion = process.env.REACT_APP_VERSION;

const versionMatch = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

const CacheBuster = props => {
  const [data, setData] = useState({ loading: true, isLatestVersion: false });
  const logger = Logger('Cache buster');
  const refreshCacheAndReload = async () => {
    logger.info('Clearing cache and hard reloading...');
    if (caches) {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }
    // delete browser cache and hard reload
    window.location.reload();
  };

  useEffect(() => {
    fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
      .then(response => response.json())
      .then(meta => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = versionMatch(latestVersion, currentVersion);
        if (shouldForceRefresh) {
          logger.warn(
            `We have a new version - ${latestVersion}. Should force refresh`,
          );
          setData({ loading: false, isLatestVersion: false });
        } else {
          logger.info(
            `You already have the latest version - ${latestVersion}. No cache refresh needed.`,
          );
          setData({ loading: false, isLatestVersion: true });
        }
      })
      .catch(err => logger.error('Cache Buster ERROR', err));
  }, []);

  return props.children({ ...data, refreshCacheAndReload });
};

export default CacheBuster;
